import React from 'react';

const Calender = () => {
  return (
    <div>
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="20" fill="#35E0A1" />
        <path
          d="M23.3333 11.6667V15M16.6667 11.6667V15M12.5 18.3333H27.5M14.1667 13.3333H25.8333C26.7538 13.3333 27.5 14.0795 27.5 15V26.6667C27.5 27.5871 26.7538 28.3333 25.8333 28.3333H14.1667C13.2462 28.3333 12.5 27.5871 12.5 26.6667V15C12.5 14.0795 13.2462 13.3333 14.1667 13.3333Z"
          stroke="#1E1E1E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
export default Calender;
